import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { resolvePageMeta, resolveBackLink } from './pageMeta';
import { vistaStrutturaAttiva } from '../components/Util/vistaStruttura';
import { usePageHeaderExtraContent, usePageHeaderStatusContent, usePageTitleOverride } from './PageHeaderExtra';

/**
 * Intestazione di pagina (titolo + sottotitolo), in cima al contenuto.
 * Il breadcrumb vive nella topbar (vedi SidBreadcrumb in Header).
 * Renderizzata una sola volta nel MainLayout.
 */
const SidPageHeader = () => {
  const location = useLocation();
  // Il sottotitolo in pageMeta resta come descrizione della pagina, ma non si mostra
  const { title: metaTitle, intro } = resolvePageMeta(location.pathname);
  const titleOverride = usePageTitleOverride();
  const title = titleOverride || metaTitle;
  const extra = usePageHeaderExtraContent();
  const status = usePageHeaderStatusContent();
  // «← Nome elenco» sopra il titolo nelle pagine di dettaglio e di creazione (set-ui schede-navigazione)
  // Nella vista struttura del super admin si torna alla sua lista (con ricerca e filtri), non a quella della struttura
  const vista = vistaStrutturaAttiva();
  const back = vista?.ritorno
    ? { to: vista.ritorno, label: resolvePageMeta(vista.ritorno.split('?')[0]).title || 'Elenco' }
    : resolveBackLink(location.pathname);

  return (
    <div className="sid-page-header">
      {back && (
        <Link to={back.to} className="sid-page-header__back">
          <span aria-hidden="true">←</span> {back.label}
        </Link>
      )}
      <div className="sid-page-header__row">
        {title && <h1 className="sid-page-header__title">{title}</h1>}
        {/* Stato del prodotto subito dopo il titolo: si cambia con un clic, senza lasciare la pagina */}
        {status && <div className="sid-page-header__status">{status}</div>}
        {extra && <div className="sid-page-header__extra">{extra}</div>}
        {/* Qui le liste con `pageList` portano i loro pulsanti (Nuovo…, Importa…) */}
        <div id="sid-page-header-actions" className="sid-page-header__actions" />
      </div>
      {/* Breve spiegazione della funzione, solo per le pagine che la prevedono (`intro` in pageMeta) */}
      {intro && <p className="sid-page-header__intro">{intro}</p>}
    </div>
  );
};

export default SidPageHeader;
